module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_download.41a8e.png";